(function () {
	'use strict';
	angular.module('app.core')
		.service('taskColumns', taskColumns);

	taskColumns.$inject = ['tableRenderService', '$experiments'];
	function taskColumns(tableRenderService, $experiments) {
		return [{
			id: 'actionStatus',
			display: 'Task Status',
			class: 'taskStatusCell',
			width: 100,
			renderer: tableRenderService.statusWithCircle,
			sort: false,
			conditional: hideFromSuppliers
		}, {
			id: 'actionCategory',
			display: 'Task Category',
			width: 120,
			sort: true,
			conditional: hideFromSuppliers,
			renderer: tableRenderService.inlineTaskList,
			idField: 'actionCategoryNdx'
		}, {
			id: 'actionOwner',
			display: 'Task Responsible',
			renderer: tableRenderService.inlineTaskList,
			sort: false,
			width: 120,
			idField: 'actionOwnerNdx',
			conditional: hideFromSuppliers
		}, {
			id: 'lastComment',
			display: 'Last Comment',
			sort: false,
			width: 120,
			renderer: tableRenderService.inlineTaskComment,
			conditional: hideFromSuppliers
		}, {
			id: 'lastCommenter',
			display: 'Last Commenter',
			sort: false,
			width: 120,
			conditional: hideFromSuppliers
		}, {
			id: 'lastCommentDate',
			display: 'Last Comment Date',
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true,
			sort: false,
			width: 120,
			conditional: hideFromSuppliers
		}, {
			id: 'actionDueDate',
			display: 'Task Due Date',
			renderer: tableRenderService.inlineTaskDueDate,
			convertTimeZone: true,
			width: 100,
			statusColumn: 'actionStatus',
			statusForCheckingPastDue: ['Open', 'Review Later'],
			conditional: hideFromSuppliers
		}, {
			id: 'actionSubject',
			display: 'Task Subject',
			width: 120,
			sort: false,
			conditional: hideFromSuppliers
		}, {
			id: 'actionDescription',
			display: 'Task Description',
			width: 150,
			sort: false,
			renderer: tableRenderService.uiBootstrapTooltip,
			conditional: hideFromSuppliers
		}, {
			id: 'actionCreator',
			display: 'Created By',
			class: 'alignLeft',
			width: 100,
			show: false
		}, {
			id: 'actionCreatedDate',
			display: 'Created Date',
			class: 'dateCell alignLeft',
			renderer: tableRenderService.dateRenderer,
			width: 100,
			show: false
		}, {
			id: 'actionCompletedDate',
			display: 'Completed Date',
			class: 'dateCell alignLeft',
			renderer: tableRenderService.dateRenderer,
			width: 100,
			convertTimeZone: true,
			show: false,
			sortDefaultReverse: true
		}, {
			id: 'actionReviewLaterExpireDate',
			display: 'Snooze End Date',
			renderer: tableRenderService.dateRenderer,
			width: 100,
			convertTimeZone: true,
			show: false
		}, {
			id: 'actionLastUpdateDate',
			display: 'Last Activity',
			class: 'dateCell alignLeft',
			renderer: tableRenderService.relativeDate,
			width: 100
		}, {
			id: 'estimatedSavings',
			display: 'Estimated Savings',
			class: 'numberCell alignRight',
			renderer: tableRenderService.currency,
			sortDefaultReverse: true,
			width: 100
		}];
	};

	function hideFromSuppliers() {
		return globalConfig.user.role !== 'Supplier';
	}
})();
